const calculateFileSize = (base64String) => {
  if (!base64String) return "0 MB";
  const sizeInBytes = base64String.length * (3 / 4);
  const sizeInMB = (sizeInBytes / (1024 * 1024)).toFixed(2);
  return `${sizeInMB} MB`;
} 

export {calculateFileSize}